export enum InterviewCreatorTeam {
  Kam = 'kam',
  CemAgc = 'cem_agc',
}
